const _ = [
  "beacon-accordion",
  "beacon-accordion-item",
  "beacon-anchor-navigation",
  "beacon-area-chart",
  "beacon-article-tile",
  "beacon-bar-chart",
  "beacon-bio-card",
  "beacon-breadcrumbs",
  "beacon-button",
  "beacon-byline",
  "beacon-carousel",
  "beacon-chart-tooltip",
  "beacon-chart-tooltip-data",
  "beacon-checkbox",
  "beacon-collection-tile",
  "beacon-contact-tile",
  "beacon-control",
  "beacon-control-group",
  "beacon-country",
  "beacon-country-selector",
  "beacon-data-list",
  "beacon-date-picker",
  "beacon-divider",
  "beacon-donut-chart",
  "beacon-drawer",
  "beacon-dropdown",
  "beacon-error",
  "beacon-error-message-summary",
  "beacon-footer",
  "beacon-gauge-chart",
  "beacon-hero",
  "beacon-icon-button",
  "beacon-id-card",
  "beacon-input-button-field",
  "beacon-input-field",
  "beacon-key-facts",
  "beacon-legacy-collection-tile",
  "beacon-legend",
  "beacon-legend-item",
  "beacon-line-chart",
  "beacon-modal",
  "beacon-multi-select",
  "beacon-multi-select-optgroup",
  "beacon-multi-select-option",
  "beacon-navigation",
  "beacon-navigation-button",
  "beacon-navigation-expanded",
  "beacon-navigation-footer",
  "beacon-navigation-popover",
  "beacon-navigation-toolbelt",
  "beacon-notification",
  "beacon-notification-group",
  "beacon-pagination",
  "beacon-pagination-button",
  "beacon-popover",
  "beacon-promo-tile",
  "beacon-quote-block",
  "beacon-radio-button",
  "beacon-radio-group",
  "beacon-region-selector",
  "beacon-scatter-chart",
  "beacon-segmented-control",
  "beacon-segmented-controls",
  "beacon-social-link",
  "beacon-social-link-container",
  "beacon-stepper",
  "beacon-tab",
  "beacon-tab-panel",
  "beacon-table",
  "beacon-table-caption",
  "beacon-table-header",
  "beacon-table-record",
  "beacon-table-stub",
  "beacon-tabs",
  "beacon-text-area",
  "beacon-toggle-button-field",
  "beacon-tooltip",
  "beacon-value-prop",
  "beacon-video",
  "beacon-video-playlist",
  "beacon-video-tag",
  "beacon-video-tile",
  "beacon-video-transcript"
], x = {
  allComponents: _
}, j = (t) => t.replace(/[A-Z]+(?![a-z])|[A-Z]/g, (e, n) => (n ? "-" : "") + e.toLowerCase()), g = (t) => /^([a-z](?![\d])|[\d](?![a-z]))+(-?([a-z](?![\d])|[\d](?![a-z])))*$|^$/.test(t);
function h(t) {
  return `${t}`.toLowerCase().replace(new RegExp(/[-_]+/, "g"), " ").replace(new RegExp(/[^\w\s]/, "g"), "").replace(new RegExp(/\s+(.)(\w*)/, "g"), (e, n, a) => `${n.toUpperCase() + a}`).replace(new RegExp(/\w/), (e) => e.toUpperCase());
}
const v = typeof process == "object" && process && process.env && process.env.UNIT_TESTING_ENV;
function f(t) {
  switch (t) {
    case "./__temp-separated/beacon-accordion/index.js":
      return import("./register-chunks/index-Bp6jI1Iv.js");
    case "./__temp-separated/beacon-accordion-item/index.js":
      return import("./register-chunks/index-Bck_NmLp.js");
    case "./__temp-separated/beacon-anchor-navigation/index.js":
      return import("./register-chunks/index-DPmvkv57.js");
    case "./__temp-separated/beacon-area-chart/index.js":
      return import("./register-chunks/index-DczgLAkp.js");
    case "./__temp-separated/beacon-article-tile/index.js":
      return import("./register-chunks/index-Do4fWJPJ.js");
    case "./__temp-separated/beacon-bar-chart/index.js":
      return import("./register-chunks/index-DmBZTLch.js");
    case "./__temp-separated/beacon-bio-card/index.js":
      return import("./register-chunks/index-nhTuYTVD.js");
    case "./__temp-separated/beacon-breadcrumbs/index.js":
      return import("./register-chunks/index-bmASM77r.js");
    case "./__temp-separated/beacon-button/index.js":
      return import("./register-chunks/index-D0uLgrRV.js");
    case "./__temp-separated/beacon-byline/index.js":
      return import("./register-chunks/index-Dw-o148L.js");
    case "./__temp-separated/beacon-carousel/index.js":
      return import("./register-chunks/index-Dmm2BiPf.js");
    case "./__temp-separated/beacon-chart-tooltip/index.js":
      return import("./register-chunks/index-awNr7i9h.js");
    case "./__temp-separated/beacon-chart-tooltip-data/index.js":
      return import("./register-chunks/index-C9dmO9Fc.js");
    case "./__temp-separated/beacon-checkbox/index.js":
      return import("./register-chunks/index-BgfZOwup.js");
    case "./__temp-separated/beacon-collection-tile/index.js":
      return import("./register-chunks/index-FYmdUULR.js");
    case "./__temp-separated/beacon-contact-tile/index.js":
      return import("./register-chunks/index-8RQC4aFE.js");
    case "./__temp-separated/beacon-control/index.js":
      return import("./register-chunks/index-Ii5R81tU.js");
    case "./__temp-separated/beacon-control-group/index.js":
      return import("./register-chunks/index-DU8_I-5t.js");
    case "./__temp-separated/beacon-country/index.js":
      return import("./register-chunks/index-DnEl-pCR.js");
    case "./__temp-separated/beacon-country-selector/index.js":
      return import("./register-chunks/index-Bgjg3esF.js");
    case "./__temp-separated/beacon-data-list/index.js":
      return import("./register-chunks/index-Dvs8ODS8.js").then((e) => e.index);
    case "./__temp-separated/beacon-date-picker/index.js":
      return import("./register-chunks/index-CHTTdCP0.js");
    case "./__temp-separated/beacon-divider/index.js":
      return import("./register-chunks/index-DdVMlqKb.js");
    case "./__temp-separated/beacon-donut-chart/index.js":
      return import("./register-chunks/index-CcHh6MoP.js");
    case "./__temp-separated/beacon-drawer/index.js":
      return import("./register-chunks/index-TbDDtC9G.js");
    case "./__temp-separated/beacon-dropdown/index.js":
      return import("./register-chunks/index-PFkymDfk.js");
    case "./__temp-separated/beacon-error/index.js":
      return import("./register-chunks/index-CGfxxJxF.js");
    case "./__temp-separated/beacon-error-message-summary/index.js":
      return import("./register-chunks/index-fB52ULxM.js");
    case "./__temp-separated/beacon-footer/index.js":
      return import("./register-chunks/index-uur04YJ7.js");
    case "./__temp-separated/beacon-gauge-chart/index.js":
      return import("./register-chunks/index-C86bIDxL.js");
    case "./__temp-separated/beacon-hero/index.js":
      return import("./register-chunks/index-I57tdpXS.js");
    case "./__temp-separated/beacon-icon-button/index.js":
      return import("./register-chunks/index-ng9L_l2y.js");
    case "./__temp-separated/beacon-id-card/index.js":
      return import("./register-chunks/index-D7gsQhD7.js");
    case "./__temp-separated/beacon-index.test-components/index.js":
      return import("./register-chunks/index-GEbPl0KT.js");
    case "./__temp-separated/beacon-input-button-field/index.js":
      return import("./register-chunks/index-C8FeIrAN.js");
    case "./__temp-separated/beacon-input-field/index.js":
      return import("./register-chunks/index-B4lMOM2_.js");
    case "./__temp-separated/beacon-key-facts/index.js":
      return import("./register-chunks/index-b16zg_La.js");
    case "./__temp-separated/beacon-legacy-collection-tile/index.js":
      return import("./register-chunks/index-BRIeqOMN.js");
    case "./__temp-separated/beacon-legend/index.js":
      return import("./register-chunks/index-DOEZeRbm.js");
    case "./__temp-separated/beacon-legend-item/index.js":
      return import("./register-chunks/index-CZtndo9R.js");
    case "./__temp-separated/beacon-line-chart/index.js":
      return import("./register-chunks/index-BcAm6guv.js");
    case "./__temp-separated/beacon-meter-chart/index.js":
      return import("./register-chunks/index-DHK0u9_K.js");
    case "./__temp-separated/beacon-modal/index.js":
      return import("./register-chunks/index-BLR2RfMm.js");
    case "./__temp-separated/beacon-multi-select/index.js":
      return import("./register-chunks/index-0f5JX6I1.js");
    case "./__temp-separated/beacon-multi-select-optgroup/index.js":
      return import("./register-chunks/index-BnyT8zuP.js");
    case "./__temp-separated/beacon-multi-select-option/index.js":
      return import("./register-chunks/index-CFb6IVY7.js");
    case "./__temp-separated/beacon-navigation/index.js":
      return import("./register-chunks/index-BLhQmkJj.js").then((e) => e.index);
    case "./__temp-separated/beacon-navigation-button/index.js":
      return import("./register-chunks/index-BLhQmkJj.js").then((e) => e.index$1);
    case "./__temp-separated/beacon-navigation-expanded/index.js":
      return import("./register-chunks/index-BLhQmkJj.js").then((e) => e.index$2);
    case "./__temp-separated/beacon-navigation-footer/index.js":
      return import("./register-chunks/index-DiINpZCB.js");
    case "./__temp-separated/beacon-navigation-popover/index.js":
      return import("./register-chunks/index-BLhQmkJj.js").then((e) => e.index$3);
    case "./__temp-separated/beacon-navigation-toolbelt/index.js":
      return import("./register-chunks/index-BLhQmkJj.js").then((e) => e.index$4);
    case "./__temp-separated/beacon-notification/index.js":
      return import("./register-chunks/index-CNteybGD.js");
    case "./__temp-separated/beacon-notification-group/index.js":
      return import("./register-chunks/index-B6heewrQ.js");
    case "./__temp-separated/beacon-pagination/index.js":
      return import("./register-chunks/index-jTb0xIt-.js");
    case "./__temp-separated/beacon-pagination-button/index.js":
      return import("./register-chunks/index-DWCDvWja.js");
    case "./__temp-separated/beacon-popover/index.js":
      return import("./register-chunks/index-CyzeOQCN.js");
    case "./__temp-separated/beacon-promo-tile/index.js":
      return import("./register-chunks/index-ApplZhY2.js");
    case "./__temp-separated/beacon-quote-block/index.js":
      return import("./register-chunks/index-DOkvooj3.js");
    case "./__temp-separated/beacon-radio-button/index.js":
      return import("./register-chunks/index-nOTp5C6r.js");
    case "./__temp-separated/beacon-radio-group/index.js":
      return import("./register-chunks/index-D624e7WW.js");
    case "./__temp-separated/beacon-region-selector/index.js":
      return import("./register-chunks/index-D-iPVWfm.js");
    case "./__temp-separated/beacon-scatter-chart/index.js":
      return import("./register-chunks/index-Cp7zX-RA.js");
    case "./__temp-separated/beacon-segmented-control/index.js":
      return import("./register-chunks/index-DzK4U78U.js");
    case "./__temp-separated/beacon-segmented-controls/index.js":
      return import("./register-chunks/index-BmLd2S0L.js");
    case "./__temp-separated/beacon-social-link/index.js":
      return import("./register-chunks/index-Bt6ptSwD.js");
    case "./__temp-separated/beacon-social-link-container/index.js":
      return import("./register-chunks/index-CQ_jdINJ.js");
    case "./__temp-separated/beacon-stepper/index.js":
      return import("./register-chunks/index-DnzfDrkP.js");
    case "./__temp-separated/beacon-tab/index.js":
      return import("./register-chunks/index-CxRiUjqX.js");
    case "./__temp-separated/beacon-tab-panel/index.js":
      return import("./register-chunks/index-DZVDUu-7.js");
    case "./__temp-separated/beacon-table/index.js":
      return import("./register-chunks/index-BcYn59_q.js");
    case "./__temp-separated/beacon-table-caption/index.js":
      return import("./register-chunks/index-DPnL2ZYy.js");
    case "./__temp-separated/beacon-table-header/index.js":
      return import("./register-chunks/index-eyrjRnO9.js").then((e) => e.index);
    case "./__temp-separated/beacon-table-record/index.js":
      return import("./register-chunks/index-GsTIa_1C.js").then((e) => e.index);
    case "./__temp-separated/beacon-table-stub/index.js":
      return import("./register-chunks/index-CbPDwFfy.js").then((e) => e.index);
    case "./__temp-separated/beacon-tabs/index.js":
      return import("./register-chunks/index-DFXyc7sX.js");
    case "./__temp-separated/beacon-text-area/index.js":
      return import("./register-chunks/index-BxH1fDgl.js");
    case "./__temp-separated/beacon-toggle-button-field/index.js":
      return import("./register-chunks/index-OFe6fJIE.js");
    case "./__temp-separated/beacon-tooltip/index.js":
      return import("./register-chunks/index-62qzV4e2.js");
    case "./__temp-separated/beacon-value-prop/index.js":
      return import("./register-chunks/index-CsXxxT7E.js");
    case "./__temp-separated/beacon-video/index.js":
      return import("./register-chunks/index-ZQ9jFTlS.js");
    case "./__temp-separated/beacon-video-playlist/index.js":
      return import("./register-chunks/index-D90Rqv_k.js");
    case "./__temp-separated/beacon-video-tag/index.js":
      return import("./register-chunks/index-BCJp8r7w.js");
    case "./__temp-separated/beacon-video-tile/index.js":
      return import("./register-chunks/index-Co8kV8QG.js");
    case "./__temp-separated/beacon-video-transcript/index.js":
      return import("./register-chunks/index-BkWVyBER.js");
    default:
      return new Promise(function(e, n) {
        (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(
          n.bind(null, new Error("Unknown variable dynamic import: " + t))
        );
      });
  }
}
const d = async (t = "", e = document.body) => {
  const n = t ? t + "-beacon-" : "beacon-", a = e instanceof Element ? e.tagName.toLowerCase() : "", o = a == null ? void 0 : a.startsWith(n), s = [...e.querySelectorAll(":not(:defined)")].map((c) => c.tagName.toLowerCase()).filter((c) => c.startsWith(n));
  o && !customElements.get(a) && s.push(a);
  const r = [...new Set(s)].map((c) => t ? c.split(`${t}-`)[1] : c);
  r.length && await C(t, r);
}, w = (t) => {
  const e = j(t);
  return g(t) || console.warn(
    `Beacon Warning: '${t}' is not a valid Beacon component tag name. Class name casing will be deprecated soon. Update to tag name "${e}".`
  ), e;
}, y = (t) => {
  const e = w(t);
  return {
    tagName: e,
    className: h(e)
  };
}, m = async (t, e, n) => new Promise((a, o) => {
  var s;
  if (typeof e == "string") {
    const { tagName: r, className: c } = y(e), b = t ? `${t}-${r}` : r;
    customElements.get(b) ? a(customElements.get(b)) : f(`./__temp-separated/${r}/index.js`).then((i) => {
      var l;
      const p = i[`${c}`];
      p.registerComponent(t), (l = p.nestedComponents) != null && l.length && Promise.all(
        p.nestedComponents.map(
          (u) => m(t, u, n)
        )
      ), a(p);
    }).catch(() => {
      const i = `Beacon Registration Error: Unable to import ${e}`;
      n ? o(new Error(i)) : a(i);
    });
  } else if (e.registerComponent) {
    const r = e;
    r.registerComponent(t), (s = r.nestedComponents) != null && s.length && Promise.all(
      r.nestedComponents.map(
        (c) => m(t, c, n)
      )
    ), a(r);
  }
}), C = async (t = "", e = [], n = !v) => {
  const a = e.length ? e : x.allComponents;
  await Promise.all(
    a.map(
      (o) => m(t, o, n)
    )
  );
}, $ = async (t = "") => {
  const e = new MutationObserver(async (n) => {
    for (const { addedNodes: a } of n)
      for (const o of a)
        o instanceof Element && await d(t, o);
  });
  return E(e), await d(t), k(t), e.observe(document.documentElement, { subtree: !0, childList: !0 }), e;
}, E = (t) => {
  const e = Element.prototype.attachShadow;
  Element.prototype.attachShadow = function(n) {
    const a = e.call(this, n);
    return this.tagName.includes("BEACON") || t.observe(a, { subtree: !0, childList: !0 }), a;
  };
}, k = (t, e = document) => {
  Array.from(e.querySelectorAll(":not([beacon-tag-name])")).filter(
    (o) => o.tagName.includes("-") && !o.tagName.includes("BEACON")
  ).forEach((o) => {
    o.shadowRoot && o instanceof HTMLElement && d(t, o.shadowRoot);
  });
};
export {
  $ as autoLoadBeaconComponents,
  k as discoverComponentsInShadowDOM,
  y as getComponentIdentifiers,
  w as getComponentTagName,
  m as importAndRegisterComponent,
  E as polyfillAttachShadowWithObserver,
  C as registerBeaconComponents
};
